<template>
  <vs-tabs :value="1">
    <vs-tab label="집단급식소 등록" @click="onClickTab(0)"> </vs-tab>
    <vs-tab label="집단급식소 현황" @click="onClickTab(1)">
      <!-- 부서명 -->
      <vx-card class="mb-8">
        <vs-row class="flex w-auto mr-4" vs-align="center">
          <vs-col class="w-auto mr-4">부서명</vs-col>
          <vs-col class="w-auto">
            <vs-select autocomplete v-model="selectedCompany">
              <vs-select-item v-for="(item, index) in companyList" :key="index" :text="item.com_name" :value="item" />
            </vs-select>
          </vs-col>
        </vs-row>
      </vx-card>

      <!-- 내용 -->
      <vx-card>
        <!-- 집단급식소 현황 -->
        <div>
          <p class="title mb-5">사업장 현황</p>
          <div class="select-table-container">
            <table class="select-table">
              <colgroup>
                <col width="84" />
              </colgroup>
              <thead>
                <th>No.</th>
                <th>사업장명</th>
                <th>담당 주무관</th>
                <th>사업기간</th>
                <th>사업금액</th>
                <th>시설물 위치(주소)</th>
              </thead>
              <tbody>
                <tr v-for="tr in table.list" :key="tr.id" :class="selectWarehouse === tr.id && 'selected'" @click="onClickSelectWarehouse(tr)">
                  <td>{{ tr.id }}</td>
                  <td>{{ tr.field_name }}</td>
                  <td>{{ tr.manager_name }}</td>
                  <td>{{ tr.work_begin_at || tr.work_end_at ? (tr.work_begin_at ? getFormattedDate(tr.work_begin_at) : '') + ' ~ ' + (tr.work_end_at ? getFormattedDate(tr.work_end_at): '') : '-' }}</td>
                  <td>{{ tr.deposit_amount | comma }}</td>
                  <td>{{ tr.address }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="vs-con-table">
            <div class="con-pagination-table vs-table--pagination">
              <k-pagination :total="lastPage ? lastPage : 1" v-model="currentPage" @change="handleChangePage"></k-pagination>
            </div>
          </div>
        </div>

        <!-- 집단급식소 정보 -->
        <div>
          <p class="title mt-8 mb-5">사업장 정보</p>
          <div class="writeGridContainer">
            <div>
              <div>사업장명</div>
              <ml-input readonly :value="!!selectWarehouseData ? selectWarehouseData.field_name : ''" />
            </div>
            <div>
              <div>담당 주무관</div>
              <ml-input readonly :value="!!selectWarehouseData ? selectWarehouseData.manager_name : ''" />
            </div>
            <div>
              <div>사업기간</div>
              <div class="w-full flex flex-1">
                <date-selector :readonly="true" :value="!!selectWarehouseData ? selectWarehouseData.work_begin_at : ''"  />
                <label class="px-2 flex" style="align-items: center">~</label>
                <date-selector :readonly="true" :value="!!selectWarehouseData ? selectWarehouseData.work_end_at : ''"  />
              </div>
            </div>
            <div>
              <div>사업금액</div>
              <comma-input readonly :value="!!selectWarehouseData ? selectWarehouseData.deposit_amount : ''" />
            </div>
            <div>
              <div>행정동<br>(사업장 주소)</div>
              <ml-input :readonly="true" :value="!!selectWarehouseData ? selectWarehouseData.address : ''" />
            </div>
            <div>
              <div>사업장 연락처</div>
              <ml-input :readonly="true" :value="!!selectWarehouseData ? selectWarehouseData.phone : ''" />
            </div>
            <div>
              <div>원료·제조물 해당 법령</div>
              <div class="w-full flex-1">
                <ml-input :readonly="true" :value="!!selectWarehouseData ? selectWarehouseData.meta.법령 : ''" class="w-full flex-1" />
                <div style="color: #696d71;">※ 중처법 제8조제3호참고</div>
              </div>
            </div>
            <div>
              <div>구체적 사용처</div>
              <ml-input :readonly="true" :value="!!selectWarehouseData ? selectWarehouseData.meta.사용처 : ''" />
            </div>
          </div>
        </div>

        <!-- 부서 정보 -->
        <!-- <company-add-module type="info" :value="!!selectWarehouseData ? selectWarehouseData.companies : []" /> -->
        <div>
          <p class="title mb-5">담당 부서(업체) 정보</p>
          <div class="select-table-container">
            <table class="select-table">
              <colgroup>
                <col width="84" />
              </colgroup>
              <thead>
                <th>No.</th>
                <th>구분</th>
                <th>부서(업체)명</th>
                <th>대표자</th>
                <th>담당자</th>
                <th>연락처</th>
              </thead>
              <tbody>
                <tr v-for="tr in companyTable.list" :key="tr.id" @click="() => onClickCompanySelectData(tr)">
                  <td>{{ tr.id }}</td>
                  <td>{{ tr.com_type }}</td>
                  <td>{{ tr.com_name }}</td>
                  <td>{{ tr.com_ceo }}</td>
                  <td>{{ tr.director }}</td>
                  <td>{{ tr.com_number }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="vs-con-table">
            <div class="con-pagination-table vs-table--pagination">
              <k-pagination :total="companyTable.lastPage ? companyTable.lastPage : 1" v-model="companyTable.currentPage" @change="handleCompanyChangePage"></k-pagination>
            </div>
          </div>
        </div>

        <!-- 부서 세부 정보 -->
        <div class="mt-8">
          <p class="title mb-5">부서(업체) 세부 정보</p>
          <div class="writeGridContainer">
            <div>
              <div>구분</div>
              <ml-input readonly :value="!!selectCompanyData ? selectCompanyData.com_type : ''" />
            </div>
            <div></div>
            <div></div>
            <div>
              <div>부서(업체)명</div>
              <ml-input readonly :value="!!selectCompanyData ? selectCompanyData.com_name : ''" />
            </div>
            <div>
              <div>대표자</div>
              <ml-input readonly :value="!!selectCompanyData ? selectCompanyData.com_ceo : ''" />
            </div>
            <div>
              <div>사업자번호</div>
              <ml-input readonly :value="!!selectCompanyData ? selectCompanyData.com_number : ''" />
            </div>
            <div>
              <div>주소</div>
              <ml-input readonly :value="!!selectCompanyData ? selectCompanyData.com_address : ''" />
            </div>
            <div>
              <div>업태</div>
              <ml-input readonly :value="!!selectCompanyData ? selectCompanyData.com_business_class : ''" />
            </div>
            <div>
              <div>업종</div>
              <ml-input readonly :value="!!selectCompanyData ? selectCompanyData.com_business_type : ''" />
            </div>
            <div>
              <div>담당자</div>
              <ml-input readonly :value="!!selectCompanyData ? selectCompanyData.director : ''" />
            </div>
            <div>
              <div>연락처</div>
              <ml-input readonly :value="!!selectCompanyData ? selectCompanyData.phone : ''" />
            </div>
          </div>
        </div>

        <!-- 참여 인원 정보 -->
        <company-user-auth-module
          :users="users"
          type="info"
        />
      </vx-card>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import FileInput from "@/components/custom/FileInput";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import SearchNavStartEnd from "@/components/nav/SearchNavStartEnd.vue";
import FileUploadModule from "@/views/modules/FileUploadModule";
import CompanyUserAuthModule from "@/views/_BS/components/CompanyUserAuthModule";
import DateSelector from "@/components/selector/DateSelector";
import KPagination from "@/components/kPagination/kPagination";
import CompanyAddModule from "@/views/_BS/components/SimpleCompanyAddModule";
import moment from "moment";

export default {
  components: {
    DateSelector,
    CompanyUserAuthModule,
    SearchNavStartEnd,
    SearchNavItemSelect,
    FileInput,
    FileUploadModule,
    KPagination,
    CompanyAddModule,
  },
  filters: {
    comma(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  data() {
    return {
      // 부서명
      selectedCompany: null,
      companyList: [],

      // 창고 현황
      currentPage: 1,
      lastPage: 1,
      total: 0,
      table: {
        list: [],
        perPage: 5,
        keyword: "",
      },
      selectWarehouse: null,
      selectWarehouseData: null,
      selectCompanyId: null,
      selectCompanyData: null,

      // 분기별 근로자 근무(예정)현황(명)
      seasonYear: new Date().getFullYear(),
      quarterData: [],

      // 부서정보
      companyTable: {
        list: [],
        page: 1,
        lastPage: 1,
        total: 0,
        perPage: 5,
      },

      keyword: "",
      users: [],
    };
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    setSeasonYear() {
      const currentYear = new Date().getFullYear();
      const list = [];
      for (let i = 2000; i <= currentYear; i++) {
        list.push(i);
      }
      return list.reverse();
    },
  },
  watch: {
    selectedCompany(/*value*/) {
      // 초기화
      this.currentPage = 1;
      this.lastPage = 1;
      this.total = 0;
      this.table = {
        list: [],
        perPage: 5,
        keyword: "",
      };
      this.selectWarehouse = null;
      this.selectWarehouseData = null;
      this.selectCompanyId = null;
      this.selectCompanyData = null;

      this.keyword = "";
      this.users = [];

      this.loadCompanyInfo();
    },
  },
  created() {
    this.initBreadcrumb();
  },
  mounted() {
    this.$store.dispatch("company/LOAD_COMPANY_TREE", { projectId: this.projectId }).then(async (value) => {
      const companyTree = value;
      const list = [];
      for (const com of companyTree) {
        list.push(com.descendant);
      }
      this.companyList = list;

      let myInfo = this.$store.state.auth.userInfo;
      if (!myInfo.company_id) {
        await this.$store.dispatch("USER_INFO");
        myInfo = this.$store.state.auth.userInfo;
      }
      this.selectedCompany = this.companyList.find((com) => com.id === myInfo.company_id);

      this.loadCompanyInfo();
      this.loadQuarterData();
    });
  },
  methods: {
    initBreadcrumb() {
      this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "중대시민재해 현황" }, { title: "집단급식소", active: true }]);
    },
    onClickTab(tabIndex) {
      if (tabIndex === 0) {
        this.$router.push({ name: "field-workplace-material-list" });
      } else if (tabIndex === 1) {
        this.$router.push({ name: "field-workplace-material-info" });
      }
    },

    // =============== 창고 현황 ===============
    loadCompanyInfo() {
      if (!this.selectedCompany) return;
      const page = this.currentPage;
      const perPage = this.table.perPage;
      const companyId = this.selectedCompany.id;
      const projectId = this.projectId;
      this.$store.dispatch("company/LOAD_COMPANY_FIELD", { companyId, projectId, fieldCode: "workplace-material", page, perPage }).then((value) => {
        const fieldListInfo = value;
        this.table.list = fieldListInfo.data;
        this.currentPage = fieldListInfo.current_page;
        this.lastPage = fieldListInfo.last_page;
        this.total = fieldListInfo.total;

        this.keyword = "";
        this.users = [];
      });
    },

    onClickSelectWarehouse(data) {
      if (data) {
        this.selectWarehouse = data.id;
        this.selectWarehouseData = JSON.parse(JSON.stringify(data));
        if (typeof this.selectWarehouseData.meta === 'string') {
          this.selectWarehouseData.meta = JSON.parse(this.selectWarehouseData.meta)
        }

        this.loadFieldCompanys();
        this.loadFieldUsers();
      }
    },
    onClickCompanySelectData(data) {
      this.selectCompanyId = data.id;
      this.selectCompanyData = data;
    },
    handleChangePage(page) {
      this.currentPage = page;
      this.loadCompanyInfo();
    },

    // =============== 분기별 근로자 근무(예정)현황(명) ===============
    async loadQuarterData() {
      const params = {
        projectId: this.projectId,
        targetYear: this.seasonYear,
      };
      const data = await this.$store.dispatch("summary/LOAD_SUMMARY_EMPLOYEE_QUARTER", params);
      this.quarterData = data.quarter;
    },

    // =============== 부서 정보 ===============
    loadFieldCompanys() {
      if (this.selectWarehouse) {
        this.$store.dispatch("project/LOAD_FIELD_COMPANYS", { fieldId: this.selectWarehouse, page: this.companyTable.page, perPage: this.companyTable.perPage }).then((result) => {
          this.companyTable.lastPage = result.last_page;
          this.companyTable.total = result.total_count;
          this.companyTable.list = result.data;
        });
      }
    },
    handleCompanyChangePage(page) {
      this.companyTable.currentPage = page;
      this.loadFieldCompanys();
    },
    selectCompany(data) {
      this.loadFieldUsers();
    },

    // =============== 참여 인원 정보 ===============
    loadFieldUsers() {
      if (this.selectWarehouse) {
        this.$store.dispatch("project/LOAD_FIELD_USERS", { fieldId: this.selectWarehouse }).then((value) => {
          this.users = value.data;
        });
      }
    },

    // =============== 기타 ===============
    jsonParse(str) {
      return JSON.parse(str);
    },
    totalNumDevices(data) {
      // 오브젝트의 value를 전부 합한 값을 리턴
      let sum = 0;
      for (const key in data) {
        sum += data[key];
      }
      return sum;
    },
    getFormattedDate(dateStr) {
      const dateMoment = moment(dateStr);
      if (dateMoment.isValid()) {
        return dateMoment.format('YYYY-MM-DD');
      } else {
        return '';
      }
    }
  },
};
</script>

<style scoped lang="scss">
.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}

.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}

.search-item {
  width: 100% !important;
  margin: 0 !important;

  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }

  &::v-deep > div:last-child {
    flex: 1 !important;

    .con-select {
      width: 100%;
    }
  }
}

.select-table-container {
  overflow-x: auto;
  table.select-table {
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;
    min-width: 1200px;

    background: #f8f8f8;
    border: 2px solid #f8f8f8;

    th,
    td {
      text-align: center;
      background: white;
      padding: 10px 15px;
    }

    td {
      cursor: pointer;
    }

    tr:nth-child(1) td {
      background: #f8f8f8;
    }

    tr.selected td {
      background: rgba(126, 114, 242, 0.6) !important;
      color: white;
    }
  }
}

table.custom {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;

  th,
  td {
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 500;
    font-size: 14px;
    text-align: center;

    background: #f9f9f9;
    padding: 15px 4px;
  }
  td {
    height: 40px;

    text-align: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;

    padding: 6px;
  }
}
</style>
